// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ - REUTILIZANDO IMPORTS EXACTOS DEL ARCHIVO ORIGINAL
// Este archivo mapea los elementos del menú actual a la nueva estructura agrupada

import React from 'react';

import DashboardIcon from "@material-ui/icons/Dashboard";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsIcon from "@material-ui/icons/Settings";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import HelpIcon from "@material-ui/icons/Help";
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import LoyaltyRoundedIcon from '@material-ui/icons/LoyaltyRounded';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import ChatIcon from '@material-ui/icons/Chat';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import SendIcon from '@material-ui/icons/Send';
import BuildIcon from '@material-ui/icons/Build';
import StorefrontOutlinedIcon from "@material-ui/icons/StorefrontOutlined";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { AllInclusive, AttachFile, DeviceHub, Event, Schedule, Speed as SpeedIcon, Assessment as AssessmentIcon } from '@material-ui/icons';
import { FaBell } from 'react-icons/fa';

const renderOutlineIcon = () => (IconComponent) => (
  <IconComponent style={{ fontSize: 20 }} />
);

const renderGroupIcon = (IconComponent) => (
  <IconComponent style={{ fontSize: 22 }} />
);

const renderIconWhatsApp = renderOutlineIcon();
const renderIconDashboard = renderOutlineIcon();
const renderIconMensajes = renderOutlineIcon();
const renderIconConfiguracion = renderOutlineIcon();
const renderIconUtilidades = renderOutlineIcon();
const renderIconGruposWA = renderOutlineIcon();
const renderIconEstadosWA = renderOutlineIcon();
const renderIconFlow = renderOutlineIcon();

// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ
export const menuGroupsConfig = {
  whatsapp: {
    id: 'whatsapp',
    titleKey: 'mainDrawer.groups.whatsapp',
    icon: renderGroupIcon(ChatIcon),
    color: '#3B82F6',
    renderIcon: renderIconWhatsApp,
    expanded: true, // ✅ Expandido por defecto
    items: [
      {
        name: 'Tickets',
        route: '/tickets',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.tickets',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Respuestas rápida',
        route: '/quick-messages',
        icon: FlashOnIcon,
        translationKey: 'mainDrawer.listItems.quickMessages',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Kanban',
        route: '/kanban',
        icon: LoyaltyRoundedIcon,
        translationKey: 'mainDrawer.listItems.kanban',
        permission: 'drawer-service-items:view',
        conditional: 'showKanban'
      },
      {
        name: 'Apuntes',
        route: '/todolist',
        icon: BorderColorIcon,
        translationKey: 'mainDrawer.listItems.todolist',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Contactos',
        route: '/contacts',
        icon: ContactPhoneIcon,
        translationKey: 'mainDrawer.listItems.contacts',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Agenda',
        route: '/appointments',
        icon: Event,
        translationKey: 'mainDrawer.listItems.appointments',
        permission: 'drawer-service-items:view',
        conditional: 'canAccessAgenda'
      },
      {
        name: 'Mensajes programados',
        route: '/schedules',
        icon: Schedule,
        translationKey: 'mainDrawer.listItems.schedules',
        permission: 'drawer-service-items:view',
        conditional: 'showSchedules'
      },
      {
        name: 'Etiquetas',
        route: '/tags',
        icon: LocalOfferIcon,
        translationKey: 'mainDrawer.listItems.tags',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Lista de archivos',
        route: '/files',
        icon: AttachFile,
        translationKey: 'mainDrawer.listItems.files',
        permission: 'drawer-service-items:view',
        conditional: 'showFiles'
      },
      {
        name: 'Chat interno',
        route: '/chats',
        icon: ForumIcon,
        translationKey: 'mainDrawer.listItems.chats',
        permission: 'drawer-service-items:view',
        conditional: 'showInternalChat'
      },
      {
        name: 'Ayuda',
        route: '/helps',
        icon: HelpIcon,
        translationKey: 'mainDrawer.listItems.helps',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'API',
        route: '/messages-api',
        icon: CodeRoundedIcon,
        translationKey: 'mainDrawer.listItems.messagesAPI',
        permission: 'drawer-admin-items:view',
        conditional: 'showExternalApi'
      }
    ]
  },

  negocio: {
    id: 'negocio',
    titleKey: 'mainDrawer.groups.negocio',
    icon: renderGroupIcon(StorefrontOutlinedIcon),
    color: '#0EA5E9',
    renderIcon: renderOutlineIcon(),
    expanded: false,
    conditional: 'showNegocio',
    items: [
      {
        kind: 'section',
        translationKey: 'mainDrawer.listItems.negocioSectionOperate',
        conditional: 'showNegocio'
      },
      {
        name: 'Resumen',
        route: '/negocio',
        icon: AssessmentOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioResumen',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Clientes',
        route: '/negocio/clientes',
        icon: PeopleAltOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioCustomers',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Servicios',
        route: '/negocio/servicios',
        icon: ShoppingCartOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioServices',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Cobros',
        route: '/negocio/cobros',
        icon: ReceiptOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioSubscriptions',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Movimientos',
        route: '/negocio/ingresos',
        icon: MonetizationOnOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioSales',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        kind: 'section',
        translationKey: 'mainDrawer.listItems.negocioSectionInventory',
        conditional: 'showNegocio'
      },
      {
        name: 'Cuentas',
        route: '/negocio/cuentas',
        icon: VpnKeyOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioAccounts',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Productos',
        route: '/negocio/productos',
        icon: StorefrontOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioProducts',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Combos',
        route: '/negocio/combos',
        icon: LocalOfferOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioCombos',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        kind: 'section',
        translationKey: 'mainDrawer.listItems.negocioSectionSetup',
        conditional: 'showNegocio'
      },
      {
        name: 'Proveedores',
        route: '/negocio/proveedores',
        icon: BusinessOutlinedIcon,
        translationKey: 'mainDrawer.listItems.negocioSuppliers',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: true
      },
      {
        name: 'Ajustes',
        route: '/negocio/configuracion',
        icon: SettingsIcon,
        translationKey: 'mainDrawer.listItems.negocioSettings',
        permission: 'drawer-service-items:view',
        conditional: 'showNegocio',
        exact: false
      }
    ]
  },
  
  dashboard: {
    id: 'dashboard',
    titleKey: 'mainDrawer.groups.dashboard',
    icon: renderGroupIcon(DashboardIcon, '#10B981'),
    color: '#10B981',
    renderIcon: renderIconDashboard,
    expanded: false,
    route: null, // ✅ Sin ruta directa - solo submenús
    items: [
      {
        name: 'Métricas',
        route: '/',
        icon: DashboardIcon,
        translationKey: 'mainDrawer.listItems.metrics',
        permission: 'dashboard:view'
      },
      {
        name: 'Encuestas de satisfacción',
        route: '/dashboard/satisfaction',
        icon: StarBorderIcon,
        translationKey: 'mainDrawer.listItems.satisfactionSurveys',
        permission: 'drawer-admin-items:view',
        conditional: 'user.superOrCompanyAdmin'
      },
      {
        name: 'Conexiones',
        route: '/dashboard/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'drawer-admin-items:view'
      },
      // ✅ ELIMINADO: "Rendimiento CPU" - Ya no se necesita, reemplazado por "Rendimiento VPS"
      {
        name: 'WhatsApp',
        route: '/dashboard/whatsapp',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.dashboardWhatsApp',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super' // Solo super admin
      },
      {
        name: 'Rendimiento VPS',
        route: '/dashboard/vps-performance',
        icon: SpeedIcon,
        translationKey: 'mainDrawer.listItems.vpsPerformance',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super' // Solo super admin
      }
    ]
  },
  
  gruposWA: {
    id: 'gruposWA',
    titleKey: 'mainDrawer.groups.gruposWA',
    icon: renderGroupIcon(PeopleIcon, '#06B6D4'),
    color: '#06B6D4',
    renderIcon: renderIconGruposWA,
    expanded: false,
    conditional: 'showGroupCampaigns',
    items: [
      {
        name: 'Lista de Grupos',
        route: '/groups-wa',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.groupsWA',
        permission: 'drawer-admin-items:view' // ✅ Solo admins pueden acceder
      },
      {
        name: 'Campañas de Grupos',
        route: '/group-campaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.groupCampaigns',
        permission: 'drawer-admin-items:view' // ✅ Solo admins pueden acceder
      },
      {
        name: 'Informe de Envío',
        route: '/group-campaign-shipping-reports',
        icon: AssessmentIcon,
        translationKey: 'mainDrawer.listItems.groupCampaignShippingReports',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Canales WhatsApp',
        route: '/newsletters-wa',
        icon: AnnouncementIcon,
        translationKey: 'mainDrawer.listItems.newslettersWA',
        permission: 'drawer-admin-items:view'
      }
    ]
  },

  estadosWA: {
    id: 'estadosWA',
    titleKey: 'mainDrawer.groups.estadosWA',
    icon: renderGroupIcon(CameraAltIcon, '#10B981'),
    color: '#10B981',
    renderIcon: renderIconEstadosWA,
    expanded: false,
    conditional: 'showStatusCampaigns',
    items: [
      {
        name: 'Estados WhatsApp',
        route: '/status-campaigns',
        icon: RadioButtonCheckedIcon,
        translationKey: 'mainDrawer.listItems.statusCampaigns',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  mensajes: {
    id: 'mensajes',
    titleKey: 'mainDrawer.groups.mensajes',
    icon: renderGroupIcon(SendIcon, '#F59E0B'),
    color: '#F59E0B',
    renderIcon: renderIconMensajes,
    expanded: false,
    items: [
      {
        name: 'Envío de mensajes',
        route: '/campaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.campaignsDispatch',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Lista de contactos',
        route: '/contact-lists',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.contactLists',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Informe de Envío',
        route: '/campaign-shipping-reports',
        icon: AssessmentIcon,
        translationKey: 'mainDrawer.listItems.campaignShippingReports',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      // ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
      // {
      //   name: 'Tiempos de envío',
      //   route: '/campaigns-config',
      //   icon: ListIcon,
      //   translationKey: 'hardcodedElements.configuracoes',
      //   permission: 'drawer-admin-items:view',
      //   conditional: 'showCampaigns'
      // }
    ]
  },
  
  configuracion: {
    id: 'configuracion',
    titleKey: 'mainDrawer.groups.configuracion',
    icon: renderGroupIcon(SettingsIcon, '#EF4444'),
    color: '#EF4444',
    renderIcon: renderIconConfiguracion,
    expanded: false,
    items: [
      {
        name: 'Conexiones',
        route: '/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Departamentos',
        route: '/queues',
        icon: AccountTreeIcon,
        translationKey: 'mainDrawer.listItems.queues',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Agentes IA',
        route: '/prompts',
        icon: AllInclusive,
        translationKey: 'mainDrawer.listItems.prompts',
        permission: 'drawer-admin-items:view',
        conditional: 'showOpenAi'
      },
      {
        name: 'Rol de usuario',
        route: '/users',
        icon: PeopleAltIcon,
        translationKey: 'mainDrawer.listItems.userRoles',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Subscripción',
        route: '/financeiro',
        icon: CardMembershipIcon,
        translationKey: 'mainDrawer.listItems.subscription',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Configuraciones',
        route: '/settings',
        icon: SettingsIcon,
        translationKey: 'mainDrawer.listItems.settings',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  flowbuilder: {
    id: 'flowbuilder',
    titleKey: 'mainDrawer.groups.flowbuilder',
    icon: renderGroupIcon(AccountTreeIcon, '#9C27B0'),
    color: '#9C27B0',
    renderIcon: renderIconFlow,
    expanded: false,
    items: [
      {
        name: 'Lista de Flujos',
        route: '/flowbuilders',
        icon: AccountTreeIcon,
        translationKey: 'mainDrawer.listItems.flowbuilders',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Campañas de Flujo',
        route: '/flowcampaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.flowcampaigns',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  utilidades: {
    id: 'utilidades',
    titleKey: 'mainDrawer.groups.utilidades',
    icon: renderGroupIcon(BuildIcon, '#8B5CF6'),
    color: '#8B5CF6',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Integraciones',
        route: '/queue-integration',
        icon: DeviceHub,
        translationKey: 'mainDrawer.listItems.queueIntegration',
        permission: 'drawer-admin-items:view',
        conditional: 'showIntegrations'
      },
      {
        name: 'Anuncios',
        route: '/announcements',
        icon: AnnouncementIcon,
        translationKey: 'mainDrawer.listItems.annoucements',
        permission: 'drawer-admin-items:view',
        conditional: 'user.superOrCompanyAdmin'
      },
      {
        name: 'Meta',
        route: '/hub-notificame',
        icon: FaBell,
        translationKey: 'mainDrawer.listItems.metaHub',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super'
      }
    ]
  }
};

// ✅ FUNCIONES HELPER
export const getMenuGroupConfig = (groupId) => {
  return menuGroupsConfig[groupId] || null;
};

export const getAllMenuGroups = () => {
  return Object.values(menuGroupsConfig);
};

export const getMenuGroupItems = (groupId) => {
  const group = getMenuGroupConfig(groupId);
  return group ? group.items : [];
};
